import { Controller } from "@hotwired/stimulus"

const $ = window.jQuery

export default class extends Controller {
  static values = {
    contactId: Number,
    contactName: String
  }

  connect() {
    this.handleCreatedContact()
    this.element.remove()
  }

  handleCreatedContact() {
    const caller = ($('#caller-id').text() || '').trim()
    const contactId = this.contactIdValue
    const contactName = this.contactNameValue

    if (caller.indexOf('redirect:') === 0) {
      window.location.href = caller.replace(/^redirect:/, '') + contactId
    } else if (caller.length > 0) {
      const $option = $('<option>')
        .val(contactId)
        .text(contactName)
        .prop('selected', true)
      $(caller).append($option).trigger('change')
    } else {
      window.location.reload()
    }
  }
}
